const NotFoundPage = () => {
  return <>Page not found</>;
};

export default NotFoundPage;
